module.exports = __webpack_public_path__ + "videos/home-bg.mp4";